import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { VehicleROIReport, VehicleROISummary } from '../types';

export const vehicleROIService = {
  getVehicleROI: async (vehicleId: number, startDate: string, endDate: string): Promise<VehicleROIReport> => {
    const response = await apiClient.get<VehicleROIReport>(API_ENDPOINTS.VEHICLE_ROI.BY_VEHICLE(vehicleId), {
      params: { startDate, endDate },
    });
    return response.data;
  },

  getVehicleROISummary: async (vehicleId: number, startDate: string, endDate: string): Promise<VehicleROISummary> => {
    const response = await apiClient.get<VehicleROISummary>(API_ENDPOINTS.VEHICLE_ROI.SUMMARY(vehicleId), {
      params: { startDate, endDate },
    });
    return response.data;
  },

  getFleetROISummary: async (startDate: string, endDate: string): Promise<VehicleROISummary[]> => {
    const response = await apiClient.get<VehicleROISummary[]>(API_ENDPOINTS.VEHICLE_ROI.FLEET_SUMMARY, {
      params: { startDate, endDate },
    });
    return response.data;
  },
};
